import { BaseApiService } from "../base/base-api.service";
import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Contact } from '../../../models/contact/contact.model';
import { ContactSerializer } from '../../../models/contact/contact-serializer.class';
import { CustomErrorHandlerService } from '../custom-error-handler.service';

@Injectable()
export class ContactService extends BaseApiService<Contact> {
  constructor(httpClient: HttpClient) {
    super(
        httpClient, 
        null, 
        "contacts", 
        new ContactSerializer(), 
        new CustomErrorHandlerService());
  }
}
